export default __webpack_public_path__ + "assets/images/3c5bd7d6ae6e0c746da95ef93637b224.jpg";